import {FC} from 'react';

import ServiceRequest from '../../components/ServiceRequests/service-request';

const ServiceRequestPage: FC = () => {
  return (
    <div>
      <ServiceRequest />
    </div>
  );
};

export default ServiceRequestPage;
